<template>
    <main class="forgetPassword">
        <hk-background></hk-background>
        <div class="forget-container">
            <p class="forget-container-tab">{{ title === 1 ? '忘记密码' : '重置密码' }}</p>
            <div v-if="step === 1" class="forget-content">
                <input v-model="phone" type="text" class="phone" placeholder="请输入手机号" />
                <div class="msg-code">
                    <input
                        v-model="code"
                        type="text"
                        class="code-input"
                        placeholder="请输入验证码"
                    />
                    <input
                        type="button"
                        :disabled="codeBtnState"
                        :value="codeText"
                        class="get-code"
                        @click="debounceSendSms"
                    />
                </div>
            </div>
            <div v-if="step === 2" class="reset-password">
                <div class="password-container">
                    <hk-password-input
                        v-model="password"
                        placeholder="请设置8~32位的数字、字母组合密码"
                        :reg="reg"
                    ></hk-password-input>
                </div>
                <div class="password-container">
                    <hk-password-input
                        v-model="rePassword"
                        placeholder="确认密码"
                        :reg="reg"
                    ></hk-password-input>
                </div>
            </div>
            <hk-button
                :text="buttonText"
                :customStyle="buttonStyle"
                :height="50"
                @handleClick="handleClick"
            ></hk-button>
            <p class="back-login flex flex-end">
                <router-link to="/login" class="back-login-btn">返回登录</router-link>
            </p>
        </div>

        <HkDialogCaptcha
            :state.sync="captchaDlgVisible"
            title=""
            buttonText="确定"
            @close="closeCaptchaDialog"
            @confirm="onCaptchaConfirm"
        >
            <template #content>
                <div class="captcha">
                    <p>验证码：<input v-model="captcha" maxlength="10" type="text" /></p>
                    <p class="hint">输入下图中的字符，不区分大小写</p>
                    <div class="image">
                        <img :src="captchaUrl" alt="" />
                        <input type="button" value="看不清，换一张" @click="getCaptchaInfo" />
                    </div>
                </div>
            </template>
        </HkDialogCaptcha>
    </main>
</template>

<script>
import HkBackground from '@components/HkBackground';
import HkButton from '@components/HkButton';
import HkPasswordInput from '@components/HkPasswordInput';
import { isNotEmpty, isPhone, validatePassword } from '@helpers/validation';
import { sendSms, captchaInfo } from '@api/common';
import { resetPassword } from '@api/forget';
import { debounce } from 'lodash';
import HkDialogCaptcha from '@components/HkDialogCaptcha';

export default {
    components: {
        HkBackground,
        HkButton,
        HkPasswordInput,
        HkDialogCaptcha
    },
    data() {
        return {
            step: 1,
            title: '忘记密码',
            phone: '',
            code: '',
            password: '',
            rePassword: '',
            codeText: '发送验证码',
            buttonStyle: {
                width: '100%',
                color: '#fff',
                shadowColor: '#D695DE',
                background: true,
                startColor: '#89009A',
                endColor: '#A60AAC'
            },
            codeBtnState: false,
            timer: '',
            time: 60,
            reg: /^(?![^a-zA-Z]+$)(?!\D+$)\w{8,32}$/,
            debounceSendSms: null,

            captchaDlgVisible: false, // 验证码对话框是否可见
            captcha: '', // 图形验证码
            captchaSessionId: '',
            captchaUrl: '' // 图形验证码URL
        };
    },
    computed: {
        buttonText() {
            if (this.step === 1) {
                return '下一步';
            } else {
                return '进入巴蜀51好课';
            }
        }
    },
    created() {
        this.debounceSendSms = debounce(this.sendCode, 1000, {
            leading: true,
            trailing: false
        });
    },
    beforeDestroy() {
        this.clearTimer();
    },
    methods: {
        validatePhone() {
            if (isPhone(this.phone)) {
                return true;
            }

            this.$message.error('请输入手机号码');
            return false;
        },
        validateCode() {
            if (isNotEmpty(this.code)) {
                return true;
            }

            this.$message.error('请输入验证码');
            return false;
        },
        validatePass() {
            if (validatePassword(this.password)) {
                return true;
            }

            this.$message.error('请设置8~32位的数字、字母组合密码');
            return false;
        },
        validateRePass() {
            if (this.rePassword === this.password) {
                return true;
            }

            this.$message.error('两次密码不一致');
            return false;
        },
        async sendCode() {
            if (this.validatePhone()) {
                this.getCaptchaInfo();
            }
        },
        clearTimer() {
            clearInterval(this.timer);
            this.timer = null;
            this.codeText = '发送验证码';
            this.codeBtnState = false;
            this.time = 60;
        },
        async handleClick() {
            if (this.step === 1) {
                if (this.validatePhone() && this.validateCode()) {
                    this.step = 2;
                }
            } else {
                if (this.validatePass() && this.validateRePass()) {
                    await resetPassword({
                        cellphone: this.phone,
                        password: this.password,
                        code: this.code
                    });
                    this.$message.success('密码修改成功');
                    this.$router.back();
                }
            }
        },
        // 获取验证码信息
        async getCaptchaInfo() {
            try {
                const resp = await captchaInfo();
                this.captchaUrl = resp.data.captcha_url;
                this.captchaSessionId = resp.data.session_id;

                this.captchaDlgVisible = true;
            } catch {
                this.$message.error('获取验证码失败');
            }
        },
        // 关闭验证码对话框
        closeCaptchaDialog() {
            this.captchaDlgVisible = false;
        },
        // 验证码对话框确定事件处理
        async onCaptchaConfirm() {
            this.captcha = this.captcha.trim();
            if (!this.captcha) {
                this.$message.error('请输入图形验证码');
                return;
            }

            this.captchaDlgVisible = false;

            this.codeBtnState = true;

            try {
                await sendSms(this.phone, this.captcha, this.captchaSessionId, 3);
                this.codeText = `${this.time}s`;
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                        this.codeText = `${this.time}s`;
                    } else {
                        this.clearTimer();
                    }
                }, 1000);
            } catch {
                this.codeBtnState = false;
                this.captcha = '';
            }
        }
    }
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
.forgetPassword {
    width: 100%;
    height: 100vh;
    min-height: 800px;
    margin: 0 auto;
    position: relative;
    .forget-container {
        box-sizing: border-box;
        width: 482px;
        height: 534px;
        background: #fff;
        box-shadow: -3px 2px 32px 0px #eaeaea;
        position: absolute;
        top: 200px;
        right: 336px;
        z-index: 99;
        padding: 82px 50px 0;
        &-tab {
            width: 100%;
            font-size: 24px;
            font-family: PingFang SC;
            font-weight: bold;
            color: #312e33;
            margin-right: 40px;
            padding-bottom: 28px;
            user-select: none;
            border-bottom: 1px solid #ededed;
            margin-bottom: 38px;
        }
        .forget-content {
            input[type='text'] {
                box-sizing: border-box;
                width: 100%;
                height: 46px;
                background: #f4f4f4;
                border: none;
                outline: none;
                margin-bottom: 26px;
                color: #a0a0a0;
                font-size: 14px;
                padding: 0 20px;
            }
            .msg-code {
                position: relative;
                .get-code {
                    position: absolute;
                    right: 20px;
                    top: 0;
                    border: none;
                    outline: none;
                    width: 70px;
                    height: 46px;
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 500;
                    color: #cccbcb;
                    padding: 0;
                    cursor: pointer;
                    background: #f4f4f4;
                }
                .code-input {
                    padding: 0 110px 0 20px;
                }
            }
        }
        .back-login {
            margin-top: 29px;
            &-btn {
                text-decoration: none;
                font-size: 16px;
                font-family: PingFang SC;
                font-weight: 500;
                color: #7d0f83;
            }
        }
    }

    .captcha {
        & > p {
            font-size: 16px;

            & > input {
                box-sizing: border-box;
                height: 46px;
                background: #f4f4f4;
                border: none;
                outline: none;
                color: #a0a0a0;
                font-size: 16px;
                padding: 0 20px;
            }
        }

        .hint {
            color: #7b7d7c;
            margin-left: 46px;
            margin-top: 4px;
            font-size: 14px;
        }

        .image {
            margin: 10px 0 20px 90px;

            & > img {
                max-width: 150px;
                max-height: 40px;
            }

            & > input {
                color: #729c9b;
                outline: none;
                border: 0;
                background: transparent;
                cursor: pointer;
            }
        }
    }
}
.error-tip {
    margin-bottom: 20px;
}
</style>
